import { createSlice } from '@reduxjs/toolkit'

export const signalRConnectionSlice = createSlice({
    name: 'signalRCurrentConnection',
    initialState: {
        connection: null,
    },
    reducers: {
        set: (state, action) => {
            state.connection = action.payload;
        },
    },
})

export const { set } = signalRConnectionSlice.actions

export default signalRConnectionSlice.reducer